export default "__VITE_ASSET__i1AvkHOF__"